import { Box, Modal, ModalDialog } from "@mui/joy";
import { Typography } from "@mui/material";
import Lottie from "lottie-react";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import CatalogLoader from "../../../animations/catalog-loader.json";

interface ILoadingUI {
  isUploading: boolean;
  setIsUploading: Dispatch<SetStateAction<boolean>>;
  progress: number;
}
export const LoadingUI = ({ isUploading, setIsUploading }: ILoadingUI) => {
  const { t } = useTranslation();

  return (
    <Modal open={isUploading} onClose={setIsUploading}>
      <ModalDialog minWidth={500}>
        <div className="text-center flex flex-col items-center justify-center">
          <Box
            sx={{
              width: "300px",
              height: "250px",
            }}
          >
            <Lottie animationData={CatalogLoader} loop={true} autoplay={true} />
          </Box>

          <Typography variant="h6">
            {t("catalog.inventory.import.tabs.zip.loading.title")}
          </Typography>
          <Typography variant="body2" whiteSpace="pre-wrap">
            {t("catalog.inventory.import.tabs.zip.loading.uploadingTxt")}
          </Typography>
        </div>
        {/* <LinearProgress color="success" determinate size="md" value={progress}>
          <Typography sx={{ fontWeight: "lg" }}>
            {`${Math.round(Number(progress))}%`}
          </Typography>
        </LinearProgress> */}
      </ModalDialog>
    </Modal>
  );
};
